<template>
    <div class="formItem" :class="{'formError' : error}">
        <label v-if="!onlyField">{{ label }}
            <span v-if="subLabel"> ({{ subLabel }})</span>
        </label>
        <v-menu
                v-model="display"
                :close-on-content-click="true"
                offset-y
                full-width
                min-width="290px"
        >
            <template v-slot:activator="{ on }">
                <v-text-field
                        v-if="readonly === false && loading === false && disabled === false"
                        v-model="textValue"
                        solo
                        flat
                        hide-details
                        class="sr-input icon-calendar"
                        v-on="on"
                ></v-text-field>
                <v-text-field
                        v-else
                        v-model="textValue"
                        solo
                        flat
                        hide-details
                        readonly
                        class="sr-input icon-calendar"
                        v-on="on"
                ></v-text-field>
            </template>
            <v-date-picker :value="datePart"
                           @input="changeValue"
                           :disabled="disabled || loading || readonly"
                           :format="format"
                           no-title
                           class="sr-datepicker"></v-date-picker>
        </v-menu>
    </div>
</template>

<script>
  import moment from 'moment'

  /**
   * The default date format for vuetify datepicker,
   * don't change this unless you change the vuetify behavior
   *
   * @type {string}
   */
  const DEFAULT_DATE_FORMAT = 'YYYY-MM-DD'
  /**
   * The default date format if type "string" is selected,
   * it will format the date accordingly
   *
   * @type {string}
   */
  const DEFAULT_DATE_FORMAT_LOCAL = 'DD.MM.YYYY'

  export default {
    props: {
      label: {
        type: String,
        default: ''
      },
      subLabel: {
        type: String,
        default: ''
      },
      onlyField: {
        type: Boolean,
        default: false
      },
      /**
       * The value, this can be a valid moment object, a Date object or a string
       * if nothing is passed it will use an empty string as default
       */
      value: {
        type: [Object, String],
        default: () => ''
      },
      loading: {
        type: Boolean,
        default: false
      },
      readonly: {
        type: Boolean,
        default: false
      },
      disabled: {
        type: Boolean,
        default: false
      },
      error: {
        type: Boolean
      },
      /**
       * The return type, this can be 'date', 'string' or 'moment'
       * if nothing is passed it will try to detect the model/value
       * and return the corresponding type
       */
      type: {
        default: () => null
      },
      /**
       * The format of the Date returned when type "string" is selected
       * and the format for the input
       */
      format: {
        type: String,
        default: () => DEFAULT_DATE_FORMAT_LOCAL
      }
    },
    methods: {
      /**
       * Event emitted by vuetify-datepicker when the selected date is changed
       */
      changeValue (value) {
        this.display = false
        this.localValue = moment(value).clone()
        this.$emit('input', this.getEmitValue())
      },
      /**
       * Get the value that should be emitted,
       * this can be either
       *    - a well formatted string provided in "format" prop
       *    - an Object of type Date
       *    - an Object of type moment
       *
       * it emits null if no type is set or no type can be detected
       */
      getEmitValue () {
        let emitValue = null
        switch (this.getType) {
          case 'string':
            emitValue = this.localValue ? this.localValue.format(this.format) : ''
            break
          case 'date':
            emitValue = this.localValue ? this.localValue.toDate() : ''
            break
          case 'moment':
            emitValue = this.localValue
            break
        }

        return emitValue
      }
    },
    data: () => ({
      display: false,
      localValue: null
    }),
    created () {
      this.localType = this.type
      // if null, autodetect the type
      if (this.localType === null) {
        this.localType = this.getType
      }

      // set the localValue accordingly
      if (this.value !== null) {
        switch (this.localType) {
          case 'string':
            if (this.format.length === this.value.length) {
              // use custom format
              this.localValue = moment(this.value, this.format)
            } else {
              // use ATOM format
              this.localValue = moment(this.value)
            }
            break
          case 'date':
            this.localValue = moment(this.value.toDateString())
            break
          case 'moment':
            this.localValue = this.value.clone()
            break
        }
      }
      this.$emit('input', this.getEmitValue())
    },
    computed: {
      /**
       * Get the type of this value, either moment, string or date
       * default is type string
       *
       * @return {string}
       */
      getType () {
        if (this.value instanceof Date) {
          return 'date'
        } else if (typeof this.value === 'string' || this.value instanceof String) {
          return 'string'
        } else if (this.value instanceof moment) {
          return 'moment'
        }
        return 'string'
      },
      /**
       * The date value for the time-picker
       */
      datePart: {
        get () {
          return this.localValue ? this.localValue.format(DEFAULT_DATE_FORMAT) : ''
        },
        set (val) {
          this.localValue = moment(val, DEFAULT_DATE_FORMAT)
          this.$emit('input', this.getEmitValue())
        }
      },

      /**
       * The date value for the text field
       */
      textValue: {
        get () {
          return this.localValue ? this.localValue.format(this.format) : ''
        },
        set (v) {
          if (this.format.length === v.length) {
            const testMoment = moment(v, this.format)
            if (testMoment.isValid() === true) {
              this.localValue = testMoment.clone()
              this.$emit('input', this.getEmitValue())
            }
          }
        }
      }
    },
    name: 'Date'
  }
</script>

<style scoped>

</style>
